import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, ActivatedRoute, NavigationCancel, Params } from '@angular/router';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { UploadKyc, UploadKycDetails } from 'src/app/upload-kyc/upload-kyc.model';
import { UploadKycService } from 'src/app/upload-kyc/upload-kyc.service';
import { CommonService } from 'src/app/common/services/common.service';
import { EKycBasicData } from 'src/app/home/home.model';
import { Globals } from 'src/app/globals';

@Component({
    selector: 'upload-kyc',
    templateUrl: './upload-kyc.component.html',
    styleUrls: ['./upload-kyc.component.css']
})
export class UploadKycComponent implements OnInit {
  isLoading: boolean = false;
  public showValidationMsgs: boolean;
  public request: UploadKyc; 
  public response: UploadKyc; 
  public validateResponseModel: EKycBasicData;
  token: string = "";
  @ViewChild("uploadKycForm") uploadKycForm: any;
  isOpenAadhaarModal: boolean = false;
  isOpenAadhaarInfoModal: boolean = false;
  private uploadedFile: File;
  isShowFileMandatory: boolean = false;
  fileErrMsg: string = "";
  isShowBackButton: boolean = false;
  isKycSuccess: boolean = false;
  isKycFailed: boolean = false;
  @ViewChild('fileData') myInputVariable: ElementRef;
  checked: any[] = [];
    
  constructor(private route: ActivatedRoute, public router: Router,public globals: Globals,private uploadKycService: UploadKycService, private commonService: CommonService) {
    this.request = new UploadKyc();
    this.response = new UploadKyc();
    if(this.request.uploadKycDetails == null || this.request.uploadKycDetails == undefined) {
      this.request.uploadKycDetails = new UploadKycDetails();
    } if(this.response.uploadKycDetails == null || this.response.uploadKycDetails == undefined) {
      this.response.uploadKycDetails = new UploadKycDetails();
    }
  }
        
  ngOnInit() {
    this.route.queryParams.subscribe(
      (params: Params) => {
        this.token = params["token"];
        this.fetchCustomerInfo();
      }
    );
    this.checked['OFFLINE-AADHAAR'] = true;
  }

  fetchCustomerInfo() {
    this.isLoading = true;
    let body = {
      "token": this.token
    }
    this.commonService.validateTokenDetails(body).subscribe(result => {
      this.isLoading= false;
      this.validateResponseModel = JSON.parse(JSON.stringify(result));
      if(this.validateResponseModel.errMsg == '' || this.validateResponseModel.errMsg == null || this.validateResponseModel.errMsg == undefined) {
        this.request.customerName = this.validateResponseModel.customerName;
        this.request.mobileNo = this.validateResponseModel.mobileNo;
        this.request.token = this.validateResponseModel.token;
        this.request.appName = this.validateResponseModel.appName;
      } else {
        this.isKycFailed = true;
      }
    });
  }

  Submit(uploadKycForm: NgForm, isValid) {
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(this.uploadKycForm.form);
      if(!this.uploadedFile){
        this.isShowFileMandatory = true;
        this.fileErrMsg = "Please upload zip format file";
      }
    } else if(!this.uploadedFile){
      this.isShowFileMandatory = true;
      this.fileErrMsg = "Please upload zip format file";
    } else {
      this.clearData();
      this.isLoading= true;
      this.request.uploadKycDetails.aadharType = "OFFLINE-AADHAAR";
      this.request.kycType = "OFFLINE-AADHAAR";
      this.uploadKycService.validateAadhaar(this.request).subscribe(result => {
        this.isLoading = false;
        this.response = JSON.parse(JSON.stringify(result));
        if(this.response.errMsg == '' || this.response.errMsg == null || this.response.errMsg == undefined) {
          this.isKycSuccess = true;
        } else {
          if(this.response.uploadKycDetails.aadhaarDetail && this.response.uploadKycDetails.aadhaarDetail.digitalSignature != null && !this.response.uploadKycDetails.aadhaarDetail.digitalSignature && this.response.errMsg.indexOf("Invalid Mobile No") !== -1) {
            this.isShowBackButton = true;
          }
          this.clearDataAfterSubmit();
        }
      });
    }
  }

  onUploadOdometerDoc(event) {
    this.clearData();
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      if (file && file.name && file.name.toLowerCase().endsWith('zip')) {
        this.uploadedFile = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          let dataUrl = reader.result;
          let base64 = dataUrl.toString().split(",")[1];
          if (base64 && base64.length > 0) {
            this.request.uploadKycDetails.fileData = base64;
            this.request.uploadKycDetails.fileName = file.name;
          };
        }
      } else {
        this.isShowFileMandatory = true;
        this.fileErrMsg = "Please upload zip format file";
        this.uploadedFile = null;
        this.myInputVariable.nativeElement.value = "";
        return;
      }
    } else {
      this.uploadedFile = null;
      this.isShowFileMandatory = true;
      this.fileErrMsg = "Please Upload the file";
      this.myInputVariable.nativeElement.value = "";
      return;
    }
  }

  openAadhaarLinkModal() {
    this.isOpenAadhaarModal = true;
  }

  redirectToAadhaarWebsite() {
    this.isOpenAadhaarModal = false;
    window.open("https://resident.uidai.gov.in/offline-kyc");
  }

  closeAadhaarLinkModal() {
    this.isOpenAadhaarModal = false;
  }

  openAadhaarInfoModal() {
    this.isOpenAadhaarInfoModal = true;
  }

  closeAadhaarInfoModal() {
    this.isOpenAadhaarInfoModal = false;
  }

  clearData() {
    this.fileErrMsg = "";
    this.isShowFileMandatory = false;
    this.uploadedFile = null;
  }

  clearDataAfterSubmit() {
    this.clearData();
    this.showValidationMsgs = false;
    this.myInputVariable.nativeElement.value = "";
    this.request.uploadKycDetails.fileName = "";
    this.request.uploadKycDetails.fileData = null;
    this.request.uploadKycDetails.shareCode = "";
  }

  goBack() {
    this.router.navigate(['/Home'], { queryParams: { 'token': this.request.token } });
  }

  setKycType(value) {
    this.request.kycType = value;
  }

  redirectToSuccessPage() {
    window.location.href = this.response.redirectURL;
  }

  redirectToErrorPage() {
    window.location.href = this.validateResponseModel.redirectURL;
  }
    
  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }
}